import './TopNav.css'
import Logo from './Logo'
import {User} from './User'
export default function TopNav(props){
    return <div className='mobi-tui-topnav'>
        <Logo/>
        {props.children}
        <User/>
    </div>
}